<template>
	<div class="page">
		<Tip tip="各子商城运营概况" />
		<el-form :inline="true" :model="tableParams" class="condition" style="margin-top: 20px;">
            <el-form-item label="">
				<el-date-picker style="max-width:240px"
					v-model="tableParams.created_date"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					placeholder="选择时间范围"
					value-format="yyyy-MM-dd" >
				</el-date-picker>
            </el-form-item>
            <el-form-item label="">
                <el-select v-model="tableParams.shop_id" placeholder="请选择账户列表">
                    <el-option label="请选择" :value="0" disabled></el-option>
                    <el-option :label="item.shop_name" :value="item.shop_id" v-for="(item,index) in shopList" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label=" ">
                <el-button @click="initData({page:1})">筛选</el-button>
            </el-form-item>
        </el-form>
		<div class="flex">
			<div class="left">
				<div class="title">
					<div>经营概况</div>
					<div class="title_dec">
						<div>*订单数量中不包含已取消订单数</div>
						<div>*订单总额中不包含售后退款、取消退款</div>
					</div>
				</div>
				<div class="left_list">
					<div class="left_item" v-for="(item,index) in operateObj" :key="index">
						<div class="left_item_num">{{item.num}}</div>
						<div class="left_item_name">{{item.name}}</div>
					</div>
				</div>
			</div>
			<div class="right">
				<div class="title">
					<div>经营曲线</div>
				</div>
				<div class="right_echarts" id="right_echarts" v-loading="shopLoad">
				</div>
			</div>
		</div>
		<div class="table" v-loading="tableLoading">
			<el-table :data="tableData" style="width: 100%" 
			:header-cell-style="{ background:'#e3e3e3',color:'#000',fontSize:'16px'}">
				<el-table-column
					type="index"
					label="序号"
					width="80" align="center">
				</el-table-column>
				<el-table-column
					prop="order_date"
					label="日期"
					align="center">
				</el-table-column>
				<el-table-column
					prop="shop_name"
					label="商城"
					align="center">
					<template slot-scope="scope">{{shop_name}}</template>
				</el-table-column>
				<el-table-column
					prop="order_count"
					label="订单数/单"
					align="center">
				</el-table-column>
				<el-table-column
					prop="order_amount"
					label="订单数/元"  align="center">
				</el-table-column>
				<el-table-column
					prop="refund_money"
					label="售后退款/元"  align="center">
				</el-table-column>
				<el-table-column
					prop="cancel_count"
					label="取消/单"  align="center">
				</el-table-column>
				<el-table-column
					prop="outcome_amount"
					label="账户支出"
					align="center">
				</el-table-column>
				<el-table-column
					prop="income_amount"
					label="账户收入"
					align="center">
				</el-table-column>
			</el-table>
			<div class="paging">
				<el-pagination background
					@size-change="initData({limit:$event})"
					:current-page.sync="tableParams.page"
					@current-change="initData({page:$event})"
					:page-size="tableParams.limit"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalNumber"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import * as echarts from 'echarts';
    import {shopSelect,shopOperate,shopOperatechart,shopOrderbyday} from "../../../request/apis.js"
	export default{
		components: {
			Tip
		},
		data(){
			return {
				list : [],
				shopLoad : false,
				tableData: [],
                tableParams : {
					limit: 10, // 每页显示条目个数
					page: 1, // 当前页数
					created_date : [],
					shop_id : 0,
					shop_name : '',
                },
				totalNumber:0,
				tableLoading : false,
				shopList : [],
				operateObj : [],
			}
		},
		mounted(){;
			this.paramData();
		},
		methods:{
			async paramData(){
                let res  = await shopSelect();
				this.shopList = res.data;
				this.initData({shop_id:res.data[0].shop_id});
				this.shop_name	= res.data[0].shop_name
			},
			initData(params={}){
				for(var key in params){
					this.tableParams[key]	= params[key];
				}
				this.tableData    = [];
				this._getData();
				// if(!params['page']&&!params['limit']){
					this.getShopOperate();
					this.getShopEcharts()
				// }
			},
			getShopOperate(){
				shopOperate(this.tableParams).then(res=>{
					this.operateObj = [
						{num:0,name:'新注册'},{num:0,name:'用户总数'},{num:0,name:'子商家数'},
						{num:0,name:'订单总数'},{num:0,name:'订单总额'},{num:0,name:'售后退款'},
						{num:0,name:'待发货单'},{num:0,name:'待收货单'},{num:0,name:'取消订单'},
						{num:0,name:'账户支出'},{num:0,name:'账户收入'},{num:0,name:'账户余额'}
					]
					let field = ['register_num','user_num','store_num','order_num','order_amount','refund_amount','send_num','receive_num','cancel_num','balance_outcome','balance_income','balance_amount']
					for(var key in field){
						this.operateObj[key].num = Number(res.data[field[key]])
					}
                })
			},
            _getData(){
                this.tableLoading = true;
                shopOrderbyday(this.tableParams).then(res=>{
                    this.tableLoading = false;
                    this.tableData  = res.data||[];
                    this.totalNumber  = Number(res.count)||1;
                })
            },
			//订单商城展示：
			async getShopEcharts() {
				this.shopLoad = true;
				let res = await shopOperatechart(this.tableParams)
				var chartDom = document.getElementById('right_echarts');
				var myChart = echarts.init(chartDom);
				var option = {
					noDataText : '没有数据',
					legend: {
						top : '20px',
						data: ['订单量','订单金额'],
					},
					grid:{
						left:'5%',
						right:'3%',
						top : '50px',
						bottom : '20px'
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: res.data.map(s=>s.date),
					},
					yAxis: {
						type: 'value',
						axisLine: {
							show: false
						}
					},
					series:[{
						data: res.data.map(s=>s.order_count),
						name : '订单量',
						type: 'line',
						smooth: true
					},{
						data: res.data.map(s=>s.order_amount),
						name : '订单金额',
						type: 'line',
						smooth: true
					}],
					tooltip : {
					trigger: 'axis',
					backgroundColor : '#f2f7fe',
					textStyle : {
						color : '#333',
						fontSize : 12,
						lineHeight : 20
					},
					extraCssText : 'text-align:left;padding:5px 10px',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: 'red'
						}
					}
					}
				};
				option && myChart.setOption(option);
				this.shopLoad = false;
			},
		}
	}
</script>

<style scoped>
	.flex{display: flex;justify-content: space-between;margin-top: 20px;}
	.left,.right{padding: 20px 20px 30px;box-shadow: 0 0 10px 0 #0000004f;border-radius: 16px;box-sizing: border-box;}
	.left{width: calc(35%  - 15px);}
	.left_list{display: flex;text-align: center;flex-wrap: wrap;justify-content: space-between;min-height: 370px;}
	.left_item{min-width: 28%;margin-top: 30px;}
	.left_item_num{font-size: 28px;margin-bottom: 5px;}
	.left_item_name{color: #666;font-size: 16px;}
	.right{width: calc(65%  - 15px);}
	.right_echarts{height: 100%;min-height: 370px;}
	.title{display: flex;justify-content: space-between;align-items: center;font-size: 22px;padding-left: 10px;font-weight: 500;}
	.title_dec{font-size: 14px;color: #777;}
	.table{margin-top: 30px;}
	.paging{margin: 10px auto 50px;text-align: center;}
</style>